import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routes from '../content/marketingRoutes.json';

export default function MarketingMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const entry = routes[pathname];
    if (!entry) return;
    const [title, description] = entry;
    document.title = title;
    const setMeta = (attribute, key, content) => {
      let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.appendChild(element); }
      element.content = content;
    };
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', `https://www.smartdeploy.io${pathname === '/' ? '' : pathname}`);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = `https://www.smartdeploy.io${pathname === '/' ? '' : pathname}`;
    // A client-side navigation away from home must not retain its product schema.
    document.head.querySelectorAll('script[data-smartdeploy-schema]').forEach(element => element.remove());
    if (pathname === '/') {
      const schema = document.createElement('script');
      schema.type = 'application/ld+json';
      schema.dataset.smartdeploySchema = 'true';
      schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': [
        { '@type': 'Organization', '@id': 'https://www.smartdeploy.io/#organization', name: 'SmartDeploy', url: 'https://www.smartdeploy.io', logo: 'https://www.smartdeploy.io/smartdeploy-mark.svg' },
        { '@type': 'Product', name: 'SmartDeploy', description, category: 'Utility construction intelligence software', url: 'https://www.smartdeploy.io', brand: { '@id': 'https://www.smartdeploy.io/#organization' } }
      ] });
      document.head.appendChild(schema);
    }
  }, [pathname]);
  return null;
}
